import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-testimonials-create',
  templateUrl: './testimonials-create.component.html',
  styleUrls: ['./testimonials-create.component.scss']
})
export class TestimonialsCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  submitted = false;
  public Form: FormGroup;

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/testimonilasbyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              _id: data.data._id,
              name: data.data.name,
              type: data.data.type,
              description: data.data.description,
              image: data.data.image,
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });

    this.Form = this.formBuilder.group({
      name: [''],
      type: ['', Validators.required],
      description: ['', Validators.required],
      image: [''],
      _id: ['']
    })
  }

  get f() { return this.Form.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    
      // console.log(this.coursename);
    if(this.action == 'Submit'){

      

    var data = {
      "name" : this.Form.value.name,
      "type" : this.Form.value.type,
      "description" : this.Form.value.description,
      "image" : this.Form.value.image,
      "admin" : sessionStorage.getItem('adminName'),
    };
    console.log(data);
    
    this.http.post<any>(this.api_endpoint+'/testimonials', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/testimonials/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured."+err);
      }
    });
    }else{
      var data1 = {
        "name" : this.Form.value.name,
        "type" : this.Form.value.type,
        "description" : this.Form.value.description,
        "image" : this.Form.value.image,
        "admin" : sessionStorage.getItem('adminName'),
        "_id" : this.Form.value._id,
      };
        // console.log(data1);     
        this.http.put<any>(this.api_endpoint+'/testimonials/', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            window.scrollTo(document.documentElement.clientWidth, 0);
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/testimonials/list-page');
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });
    }
  }

}
